import { Alert, Button, notification, Spin, Table } from "antd";
import { ColumnProps } from "antd/lib/table";
import * as MovieApi from "movieapi";
import { SaveMoviePrediction } from "movieapi";
import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import AuthService from "src/helpers/AuthService";

// tslint:disable-next-line: no-empty-interface
export interface IHistoryPageProps extends RouteComponentProps<any> {}

// tslint:disable-next-line: no-empty-interface
export interface IHistoryPageState {
  predictionData?: MovieApi.SaveMoviePrediction[];
}

export default class HistoryPage extends React.Component<
  IHistoryPageProps,
  IHistoryPageState
> {
  constructor(props: IHistoryPageProps) {
    super(props);

    this.state = {};
    this.displayErrorMessage = this.displayErrorMessage.bind(this);
    this.handleOnRow = this.handleOnRow.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.getPredictions = this.getPredictions.bind(this);
    this.deletePrediction = this.deletePrediction.bind(this);
  }

  public componentWillMount() {
    this.getPredictions();
  }

  public render() {
    if (this.state.predictionData) {
      const predictionData = this.state.predictionData;
      const columns: Array<ColumnProps<SaveMoviePrediction>> = [
        {
          dataIndex: "prediction_name",
          title: "Prediction Name"
        },
        {
          dataIndex: "revenue",
          render: t => this.formatMoney(t),
          title: "Revenue"
        },
        {
          dataIndex: "lowerBound",
          render: t => this.formatMoney(t),
          title: "Lower Bound"
        },
        {
          dataIndex: "upperBound",
          render: t => this.formatMoney(t),
          title: "Upper Bound"
        },
        {
          key: "action",
          render: (text, record, index) => {
            const handleDelete = (e: React.MouseEvent) => {
              e.preventDefault();
              e.stopPropagation();
              // tslint:disable-next-line: no-console
              console.log(record);
              // tslint:disable-next-line: no-console
              console.log(index);

              const newPredictionData = predictionData.slice();
              const deletedPrediction = newPredictionData.splice(index, 1)[0];

              // tslint:disable-next-line: no-console
              console.log(deletedPrediction.prediction_name);
              this.deletePrediction(deletedPrediction.prediction_name).then(
                ok => {
                  if (ok) {
                    this.setState({ predictionData: newPredictionData });
                  }
                }
              );
            };
            return (
              <span>
                <Button type="danger" onClick={handleDelete}>
                  Delete
                </Button>
              </span>
            );
          },
          title: "Action"
        }
      ];
      return (
        <Table
          columns={columns}
          dataSource={predictionData}
          onRow={this.handleOnRow}
          pagination={false}
        />
      );
    } else {
      return (
        <div>
          <Spin>
            <Alert
              message="Loading Predictions"
              description="This may take a second."
              type="info"
            />
          </Spin>
        </div>
      );
    }
  }

  private deletePrediction(predictionName: string) {
    const api = new MovieApi.PredictionApi(
      new AuthService().getConfiguration(),
      process.env.REACT_APP_BASE_URL
    );
    return api
      .deletePredictionData({ prediction_name: predictionName })
      .then(res => {
        this.displaySuccessMessage("deleted prediction", `${predictionName}`);
        return true;
      })
      .catch(err =>
        (err as Response).json().then(data => {
          this.displayErrorMessage(
            "failed to delete predictions",
            data.message
          );
          return false;
        })
      );
  }

  private getPredictions() {
    const api = new MovieApi.PredictionApi(
      new AuthService().getConfiguration(),
      process.env.REACT_APP_BASE_URL
    );
    api
      .getPredictionData()
      .then(res => {
        this.setState({ predictionData: res.predictions });
      })
      .catch(err =>
        (err as Response).json().then(data => {
          this.displayErrorMessage(
            "failed to download predictions",
            data.message
          );
        })
      );
  }

  private handleOnRow(record: SaveMoviePrediction, index: number) {
    return {
      onClick: (e: MouseEvent) => this.handleRowClick(e, record)
    };
  }

  private handleRowClick(e: MouseEvent, record: SaveMoviePrediction) {
    this.props.history.push("prediction", {
      data: record as MovieApi.MovieInfoOutput,
      prediction: record as MovieApi.Prediction
    });
  }

  private displayErrorMessage(message: string, description: string) {
    notification.error({
      description,
      message
    });
  }

  private displaySuccessMessage(message: string, description: string) {
    notification.success({
      description,
      message
    });
  }
  private formatMoney(money: number) {
    return new Intl.NumberFormat("en-US", {
      currency: "USD",
      style: "currency"
    }).format(money);
  }
}



// WEBPACK FOOTER //
// ./src/components/historyPage/HistoryPage.tsx